import groq from 'groq';

export const LinkFragment = groq`
    "url": link.url,
    "text": link.text
`;

export const LinkReferenceFragment = groq`
    _type == 'reference' => @->{
        "_id": @._id,
        "_type": @._type,
        ${LinkFragment}
    }
`;
